import React from 'react'

function StatistiqueHeader({nbreTotal,icone,title}) {
  return (
    <div className='px-4 py-2'>
      <div className='d-flex gap-2 align-items'>
        {icone}
        <h3>{nbreTotal}</h3>
      </div>
      <span>{title}</span>
    </div>
  )
}

export default StatistiqueHeader
